import React, {useEffect, useState} from "react";
import {
    Breadcrumb,
    Checkbox,
    Divider,
    Layout,
    Row,
    Table,
    Tag,
    Typography,
    Modal,
    Button,
    DatePicker,
    Select, Space, Input, Col, Radio
} from "antd";
import moment from "moment/moment";
import Api from "../api";
import {Link} from "react-router-dom";
import InvoiceModal from "../components/invoice-modal";
import InvoicesTable from "../components/invoices-table";

const {Title} = Typography;
const {Content} = Layout;
const { RangePicker } = DatePicker;

const Invoices = () => {
    // State to manage whether to show free invoices
    const [showFree, setShowFree] = useState(true);
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [meta, setMeta] = useState(false);
    const [status, setStatus] = useState('');
    const [firstTotal, setFirstTotal] = useState('');
    const [dates, setDates] = useState("");
    const [page, setPage] = useState(1);
    const [itemId, setItemId] = useState('');
    const [predefinedTags, setPredefinedTags] = useState([]);

    useEffect(() => {
        Api.get('/admin/banners/available-billing').then(res => {
            console.log(res.data);
            setPredefinedTags(res.data)
        })
    }, [])

    useEffect(() => {
        loadInvoices();
    }, [status, dates, page, itemId, firstTotal]);

    useEffect(() => {
        setPage(1);
    }, [itemId]);


    const loadInvoices = () => {
        setLoading(true);

        let startDate = dates.startDate;
        let endDate = dates.endDate;

        let dateparams = startDate && endDate ? `&start_date=${startDate}&end_date=${endDate}` : '';
        let params = status !== '' ? ('&status=' + status) : '';
        let itemParam = itemId ? `&billing_plan_id=${itemId}` : '';  // Add item_id filter
        let total = firstTotal ? `&first_total=${firstTotal}` : '';  // Add first_total filter

        Api.get(`/admin/latest-invoices?page=${page}${params}${dateparams}${itemParam}${total}`).then(res => {
            setMeta(res.data);
            setInvoices(res.data.data);
            setLoading(false);
        }).catch(error => {
            console.error("Error fetching data:", error);
        });
    };

    const onChange = (data) => {
        setPage(data.current);
    };

    console.log(page);

    const handleRangeChange = (dates, dateStrings) => {
        if (dates) {
            const startDateString = dateStrings[0];
            const endDateString = dateStrings[1];

            setPage(1);
            setDates({
                startDate: startDateString,
                endDate: endDateString,
            })
        } else {
            setPage(1);
            setDates(false)
        }
    };

    const exportCsv = () => {
        let startDate = dates?.startDate;
        let endDate = dates?.endDate;

        let dateparams = startDate && endDate ? `&start_date=${startDate}&end_date=${endDate}` : '';
        let params = status !== '' ? `&status=${status}` : '';
        let itemParam = itemId ? `&billing_plan_id=${itemId}` : '';

        Api.get(
            `/admin/latest-invoices?${params}${dateparams}${itemParam}&per_page=1000`
        )
            .then(res => {
                const data = res.data?.data || [];

                console.log(res.data.data);

                if (!data.length) return;

                // CSV headers
                const headers = [
                    'invoice_id',
                    'public_id',
                    'user_id',
                    'email',
                    'paysys_id',
                    'status',
                    'currency',
                    'first_total',
                    'rebill_date',
                    'due_date',
                    'tm_added',
                    'comment',
                ];

                const itemHeaders = [
                    'item_title',
                    'item_description',
                    'billing_plan_id',
                    'qty',
                    'first_price',
                    'first_total',
                    'first_period'
                ];

                const csvHeaders = [...headers, ...itemHeaders];

                // CSV rows
                const rows = data.flatMap(inv =>
                    (inv.items || []).map(item => [
                        inv.invoice_id,
                        inv.public_id,
                        inv.user_id,
                        inv.fitlap_user?.email || '',
                        inv.paysys_id,
                        inv.status,
                        inv.currency,
                        Number(inv.first_total).toFixed(2),
                        inv.rebill_date,
                        inv.due_date,
                        inv.tm_added,
                        inv.comment,

                        item.item_title,
                        item.item_description,
                        item.billing_plan_id,
                        item.qty,
                        Number(item.first_price).toFixed(2),
                        Number(item.first_total).toFixed(2),
                        item.first_period
                    ])
                );

                const csvContent = [
                    csvHeaders.join(','),
                    ...rows.map(row =>
                        row.map(value =>
                            `"${String(value ?? '').replace(/"/g, '""')}"`
                        ).join(',')
                    )
                ].join('\n');

                const blob = new Blob([csvContent], {
                    type: 'text/csv;charset=utf-8;',
                });

                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');

                link.href = url;
                link.download = `invoices_${Date.now()}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.error('CSV export failed:', error);
            });
    };

    return (
        <Content style={{margin: '0 16px'}}>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item>Fitlap</Breadcrumb.Item>
                <Breadcrumb.Item>Invoices</Breadcrumb.Item>
            </Breadcrumb>

            <div className="site-layout-card">
                <Divider orientation="left">
                    <Title style={{margin: 0}} level={4}>Invoices ({meta.total})</Title>

                </Divider>

                <Row type="flex" justify="end">
                    <Space>
                        <Button
                            type="primary"
                            onClick={exportCsv}
                        >
                            Export CSV
                        </Button>

                            <Select
                                style={{ minWidth: 220 }}
                                placeholder="Select product"
                                allowClear
                                value={itemId || undefined}
                                onChange={(value) => {
                                    setPage(1);
                                    setItemId(value || "");
                                }}
                                options={predefinedTags.map(tag => ({
                                    label: tag.title,
                                    value: tag.plan_id,
                                }))}
                            />

                        <Input
                            placeholder="First Total >= €"
                            onChange={(e) => {
                                setPage(1);
                                setFirstTotal(e.target.value);  // Update itemId state
                            }}
                            style={{ width: 150 }}
                        />

                        <Select onChange={(value) => {
                            setPage(1)
                            setStatus(value)
                        }} defaultValue={'-- Choose status --'} style={{minWidth: 160}}>
                            <Select.Option value={''}>-- Choose status --</Select.Option>
                            <Select.Option value={0}>Pending</Select.Option>
                            <Select.Option value={1}>Paid</Select.Option>
                            <Select.Option value={2}>Recurring active</Select.Option>
                            <Select.Option value={3}>Recurring cancelled</Select.Option>
                            <Select.Option value={4}>Recurring failed</Select.Option>
                            <Select.Option value={5}>Recurring finished</Select.Option>
                            <Select.Option value={7}>Chargeback</Select.Option>
                        </Select>

                        <RangePicker onChange={handleRangeChange}/>

                        <Input
                            placeholder="Search by Product ID"
                            onChange={(e) => {
                                setPage(1);
                                setItemId(e.target.value);  // Update itemId state
                            }}
                            style={{ width: 200 }}
                        />
                    </Space>
                </Row>

                <br/>

                <InvoicesTable invoices={invoices} onChange={onChange} loading={loading} meta={meta}/>
            </div>
        </Content>
    )
}

export default Invoices;